import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import logo from '../assets/sfacoctg.jpeg';
import { useLoginModal } from '../components/LoginModalContext';
import {
  getAlumniContent,
  getDefaultAlumniContent,
  getDefaultHomePageContent,
  getDefaultSiteContent,
  getPublicMemberCount,
  getPublicEvents,
  getHomePageContent,
  getSiteContent
} from '../services/authService';
import { useAuth } from '../context/AuthContext';
import PublicUserMenu from '../components/PublicUserMenu';

export default function Home() {
  const [homeContent, setHomeContent] = useState(getDefaultHomePageContent());
  const [siteContent, setSiteContent] = useState(getDefaultSiteContent());
  const [alumniContent, setAlumniContent] = useState(getDefaultAlumniContent());
  const [memberCount, setMemberCount] = useState(0);
  const [events, setEvents] = useState([]);
  const [activeSlide, setActiveSlide] = useState(0);
  const [activeEventSlide, setActiveEventSlide] = useState(0);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { openLogin, openRegister } = useLoginModal();
  const { isAuthenticated, user, logout } = useAuth();
  const slides = homeContent.slides || [];
  const bannerSlides = Array.isArray(alumniContent.banners) && alumniContent.banners.length
    ? alumniContent.banners
    : slides;
  const bannerTitle =
    alumniContent.alumniName ||
    siteContent.brandTitle ||
    siteContent.companyName;
  const bannerDescription =
    alumniContent.alumniDescription ||
    homeContent.heroLead ||
    siteContent.brandSubtitle ||
    '';
  const heroEyebrow = homeContent.heroEyebrow || 'Alumni Group';
  const heroStatValue = String(memberCount);
  const heroStatLabel = 'Active alumni members';
  const bannerHeading =
    alumniContent.bannerHeading ||
    'Reconnect with the alumni who shaped your story.';
  const resolveSlideImage = (slide) =>
    slide?.imageUrl ||
    slide?.image ||
    slide?.bannerImage ||
    slide?.banner_image ||
    siteContent.logoUrl ||
    logo;

  useEffect(() => {
    getHomePageContent()
      .then((content) => setHomeContent(content))
      .catch(() => {});
    getPublicEvents()
      .then((list) => setEvents(Array.isArray(list) ? list : []))
      .catch(() => {});
    getPublicMemberCount()
      .then((count) => setMemberCount(count))
      .catch(() => {});
    getAlumniContent()
      .then((content) => setAlumniContent(content))
      .catch(() => {});
    getSiteContent()
      .then((content) => setSiteContent(content))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!bannerSlides.length) return undefined;
    const timer = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % (bannerSlides.length || 1));
    }, 7000);
    return () => clearInterval(timer);
  }, [bannerSlides.length]);

  useEffect(() => {
    if (!bannerSlides.length) {
      setActiveSlide(0);
      return;
    }
    setActiveSlide((prev) => prev % bannerSlides.length);
  }, [bannerSlides.length]);

  useEffect(() => {
    if (!events.length) {
      setActiveEventSlide(0);
      return;
    }
    setActiveEventSlide((prev) => prev % events.length);
  }, [events.length]);

  useEffect(() => {
    if (!events.length) return undefined;
    const timer = setInterval(() => {
      setActiveEventSlide((prev) => (prev + 1) % (events.length || 1));
    }, 6000);
    return () => clearInterval(timer);
  }, [events.length]);

  const goToPrevEvent = () => {
    if (!events.length) return;
    setActiveEventSlide((prev) => (prev - 1 + events.length) % events.length);
  };

  const goToNextEvent = () => {
    if (!events.length) return;
    setActiveEventSlide((prev) => (prev + 1) % events.length);
  };

  return (
    <div className="dashboard">
      <div className="dashboard-topbar">
        <div className="dashboard-topbar-left">
          <span>{siteContent.companyName}</span>
          <span className="dot" />
          <span>{siteContent.topHeaderAddress}</span>
          <span className="dot" />
          <span>{siteContent.topHeaderEmail}</span>
          <span className="dot" />
          <span>{siteContent.topHeaderPhone}</span>
        </div>
        <div className="dashboard-topbar-right">
          <a href={siteContent.linkedinUrl} target="_blank" rel="noreferrer">LinkedIn</a>
          <a href={siteContent.instagramUrl} target="_blank" rel="noreferrer">Instagram</a>
          <a href={siteContent.facebookUrl} target="_blank" rel="noreferrer">Facebook</a>
          <a href={siteContent.whatsappUrl} target="_blank" rel="noreferrer">WhatsApp</a>
        </div>
      </div>

      <header className="dashboard-header">
        <div className="brand">
          <img className="brand-logo" src={siteContent.logoUrl || logo} alt="Safco CTG logo" />
          <div>
            <p className="brand-title">{siteContent.brandTitle}</p>
            <p className="brand-subtitle">{siteContent.brandSubtitle}</p>
          </div>
        </div>
        <nav className={`dashboard-nav ${mobileMenuOpen ? 'open' : ''}`}>
          <Link to="/">Home</Link>
          <Link to="/members">Members</Link>
          <Link to="/stories">Stories</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <div className="mobile-actions">
            {!isAuthenticated && (
              <>
                <button className="ghost-button" type="button" onClick={openLogin}>Login</button>
                <button className="ghost-button" type="button" onClick={openRegister}>Register</button>
              </>
            )}
            {isAuthenticated && (
              <>
                <Link className="ghost-button" to={user?.role === 'admin' ? '/dashboard/admin' : '/dashboard/member'}>Dashboard</Link>
                <button className="ghost-button" type="button" onClick={logout}>Logout</button>
              </>
            )}
            <Link className="ghost-button" to="/submit-payment">Donate</Link>
            <Link className="solid-button" to="/submit-payment">Submit Payment</Link>
          </div>
        </nav>
        <div className="dashboard-actions">
          {!isAuthenticated && (
            <>
              <button className="ghost-button" type="button" onClick={openLogin}>Login</button>
              <button className="ghost-button" type="button" onClick={openRegister}>Register</button>
            </>
          )}
          {isAuthenticated && (
            <PublicUserMenu />
          )}
          <Link className="ghost-button" to="/submit-payment">Donate</Link>
          <Link className="solid-button" to="/submit-payment">Submit Payment</Link>
        </div>
        <button
          className="menu-toggle"
          type="button"
          onClick={() => setMobileMenuOpen((prev) => !prev)}
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </header>

      <main>
        <section className="dashboard-hero" id="stories">
          <div className="hero-text">
            <p className="eyebrow">{heroEyebrow}</p>
            <h1>{bannerTitle}</h1>
            {siteContent.brandSubtitle && (
              <p className="banner-subtitle">{siteContent.brandSubtitle}</p>
            )}
            <p className="lead">{bannerDescription}</p>
            <div className="hero-stats">
              <div className="hero-stat-card">
                <h3>{heroStatValue}</h3>
                <p>{heroStatLabel}</p>
              </div>
            </div>
          </div>

          <div className="hero-slider" aria-live="polite">
            {bannerSlides.map((slide, index) => (
              <div
                key={`${slide.title || 'slide'}-${index}`}
                className={`slide ${index === activeSlide ? 'active' : ''}`}
              >
                <img
                  className="slide-image"
                  src={resolveSlideImage(slide)}
                  alt={slide.heading || slide.title || bannerHeading || bannerTitle}
                />
                {(slide.heading || slide.title || bannerHeading) && (
                  <div className="slide-overlay">
                    <h2>{slide.heading || slide.title || bannerHeading}</h2>
                  </div>
                )}
              </div>
            ))}
            <div className="slide-controls">
              {bannerSlides.map((slide, index) => (
                <button
                  key={`${slide.tag || slide.title || 'slide-dot'}-${index}`}
                  className={index === activeSlide ? 'active' : ''}
                  onClick={() => setActiveSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="dashboard-section" id="events">
          <div className="section-heading">
            <h2>{homeContent.eventsHeading}</h2>
            <p>{homeContent.eventsSubheading}</p>
          </div>
          <div className="events-carousel">
            <button
              type="button"
              className="event-nav-btn"
              onClick={goToPrevEvent}
              aria-label="Previous event"
            >
              ‹
            </button>

            <div className="event-stage" aria-live="polite">
              {events.map((event, index) => (
                <article
                  key={`${event.id || event.title}-${index}`}
                  className={`event-slide ${index === activeEventSlide ? 'active' : ''}`}
                >
                  <p className="event-slide-tag">Featured Event</p>
                  <h3>{event.title}</h3>
                  <p>
                    {event.dateLabel
                      ? `${event.dateLabel}${event.description ? ` · ${event.description}` : ''}`
                      : event.description}
                  </p>
                  <div className="event-slide-actions">
                    <button
                      type="button"
                      className="ghost-button small"
                      onClick={() => setSelectedEvent(event)}
                    >
                      Read more
                    </button>
                    <button
                      type="button"
                      className="solid-button small"
                      onClick={() => {
                        if (event.actionUrl) {
                          window.open(event.actionUrl, '_blank', 'noopener,noreferrer');
                        } else {
                          setSelectedEvent(event);
                        }
                      }}
                    >
                      {event.action || 'Join now'}
                    </button>
                  </div>
                </article>
              ))}
            </div>

            <button
              type="button"
              className="event-nav-btn"
              onClick={goToNextEvent}
              aria-label="Next event"
            >
              ›
            </button>
          </div>
          <div className="event-dots">
            {events.map((event, index) => (
              <button
                key={`${event.title}-${index}`}
                className={index === activeEventSlide ? 'active' : ''}
                onClick={() => setActiveEventSlide(index)}
                aria-label={`Go to event ${index + 1}`}
              />
            ))}
          </div>
        </section>

        <section className="dashboard-section newsletter">
          <div>
            <h2>{homeContent.newsletterHeading}</h2>
            <p>{homeContent.newsletterText}</p>
          </div>
          <div className="newsletter-actions">
            <input type="email" placeholder="Email address" />
            <button className="solid-button">Subscribe</button>
          </div>
        </section>
      </main>

      <footer className="dashboard-footer">
        <div>
          <img className="footer-logo" src={logo} alt="Safco CTG logo" />
          <h3>SFACO-CTG</h3>
          <p>
            Building lifelong connections between graduates, students, and faculty.
          </p>
        </div>
        <div className="footer-links">
          <div>
            <h4>Community</h4>
            <a href="#events">Events</a>
            <Link to="/stories">Stories</Link>
          </div>
          <div>
            <h4>Support</h4>
            <a href="#giving">Giving</a>
            <Link to="/stories">Mentorship</Link>
            <a href="#events">Volunteer</a>
          </div>
          <div>
            <h4>Resources</h4>
            <Link to="/stories">Newsroom</Link>
            <a href="#events">Alumni directory</a>
            <a href="#giving">Contact</a>
          </div>
        </div>
      </footer>

      {selectedEvent && (
        <div className="event-modal" role="dialog" aria-modal="true" aria-labelledby="event-modal-title">
          <div className="event-modal-backdrop" onClick={() => setSelectedEvent(null)} aria-hidden="true" />
          <div className="event-modal-card">
            <button
              type="button"
              className="event-modal-close"
              onClick={() => setSelectedEvent(null)}
              aria-label="Close event details"
            >
              ×
            </button>
            <p className="event-modal-eyebrow">Event details</p>
            <h3 id="event-modal-title">{selectedEvent.title}</h3>
            <p>
              {selectedEvent.dateLabel
                ? `${selectedEvent.dateLabel}${selectedEvent.description ? ` · ${selectedEvent.description}` : ''}`
                : selectedEvent.description}
            </p>
            <div className="event-modal-actions">
              <button
                type="button"
                className="solid-button"
                onClick={() => {
                  if (selectedEvent.actionUrl) {
                    window.open(selectedEvent.actionUrl, '_blank', 'noopener,noreferrer');
                  }
                }}
              >
                {selectedEvent.action || 'Join now'}
              </button>
              <button type="button" className="ghost-button" onClick={() => setSelectedEvent(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
